import React from 'react'

const FbIcon = () => {
    return (
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="37.024" height="37.024" rx="10.68" fill="#F6F6F6" />
            <path d="M22.4367 19.2687L22.9311 16.0473H19.8401V13.9569C19.8401 13.0756 20.2719 12.2165 21.6562 12.2165H23.0614V9.47384C23.0614 9.47384 21.7862 9.25621 20.567 9.25621C18.0215 9.25621 16.3576 10.7991 16.3576 13.5922V16.0473H13.528V19.2687H16.3576V27.0562H19.8401V19.2687H22.4367Z" fill="#191919" />
        </svg>

    )
}

export default FbIcon